import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/common/SEO';
import Breadcrumbs from '../../components/common/Breadcrumbs';
import RelatedGuides from '../../components/common/RelatedGuides';

export default function DayTrips() {
  const dayTrips = [
    {
      title: 'Pacaya Volcano',
      duration: '4-5 hours',
      distance: '1.5 hours',
      difficulty: 'Easy to Moderate',
      description: 'Hike to active lava flows on this accessible volcano. Perfect for families and those short on time.',
      bestFor: 'First-time volcano hikers, families, travelers with limited time',
      worthIt: 'Absolutely. The most accessible active volcano experience in Guatemala with guaranteed lava sightings.',
      image: 'https://public.readdy.ai/ai/img_res/9e91aeab75a261eb85b3cafce120a8d0.jpg',
      link: '/pacaya-volcano-day-trip-from-antigua'
    },
    {
      title: 'Lake Atitlán',
      duration: 'Full day (10-12 hours)',
      distance: '2.5-3 hours',
      difficulty: 'Easy',
      description: 'Visit Guatemala\'s stunning volcanic lake surrounded by traditional villages and dramatic scenery.',
      bestFor: 'Nature lovers, photographers, cultural explorers',
      worthIt: 'Yes, if you have a full day. One of Guatemala\'s most beautiful natural wonders with indigenous culture.',
      image: 'https://readdy.ai/api/search-image?query=Lake%20Atitlan%20Guatemala%20panoramic%20view%2C%20three%20volcanoes%2C%20colorful%20lakeside%20villages%2C%20traditional%20boats%2C%20stunning%20natural%20beauty%2C%20day%20trip%20destination&width=600&height=400&seq=atitlan-trip&orientation=landscape',
      link: '/antigua-to-lake-atitlan-shuttle'
    },
    {
      title: 'Chichicastenango Market',
      duration: 'Full day (8-10 hours)',
      distance: '2 hours',
      difficulty: 'Easy',
      description: 'Experience Guatemala\'s most famous indigenous market. Colorful textiles, handicrafts, and authentic culture.',
      bestFor: 'Shoppers, culture enthusiasts, photographers',
      worthIt: 'Highly recommended on Thursday or Sunday (market days). The most authentic market experience in Guatemala.',
      image: 'https://readdy.ai/api/search-image?query=Chichicastenango%20market%20Guatemala%20vibrant%20scene%2C%20colorful%20textiles%20hanging%2C%20indigenous%20vendors%2C%20traditional%20handicrafts%2C%20bustling%20cultural%20market%2C%20authentic%20atmosphere&width=600&height=400&seq=chichi-trip&orientation=landscape',
      link: '/antigua-to-chichicastenango'
    },
    {
      title: 'Acatenango Overnight Hike',
      duration: '2 days / 1 night',
      distance: '1.5 hours to trailhead',
      difficulty: 'Challenging',
      description: 'Camp overnight with views of erupting Fuego volcano. Guatemala\'s most epic hiking experience.',
      bestFor: 'Fit hikers, adventure seekers, volcano enthusiasts',
      worthIt: 'If you\'re physically prepared, this is the highlight of many Guatemala trips. Unforgettable experience.',
      image: 'https://readdy.ai/api/search-image?query=Acatenango%20volcano%20Guatemala%20night%20camp%2C%20Fuego%20eruptions%20glowing%2C%20tents%20under%20stars%2C%20dramatic%20volcanic%20landscape%2C%20epic%20overnight%20adventure&width=600&height=400&seq=acatenango-daytrip&orientation=landscape',
      link: '/acatenango-hike-from-antigua'
    },
    {
      title: 'Coffee Plantation Tour',
      duration: '3-4 hours',
      distance: '15-30 minutes',
      difficulty: 'Easy',
      description: 'Tour world-class coffee farms, learn about production, and taste some of Guatemala\'s finest beans.',
      bestFor: 'Coffee lovers, relaxed travelers, morning activities',
      worthIt: 'Great half-day activity. Educational and delicious, perfect for coffee enthusiasts.',
      image: 'https://readdy.ai/api/search-image?query=Antigua%20Guatemala%20coffee%20plantation%20tour%2C%20coffee%20beans%20on%20plants%2C%20traditional%20processing%2C%20farm%20workers%2C%20lush%20green%20hillside%2C%20coffee%20culture%20experience&width=600&height=400&seq=coffee-trip&orientation=landscape',
      link: '/antigua-guatemala-travel-guide'
    },
    {
      title: 'Iximché Ruins',
      duration: '4-5 hours',
      distance: '1 hour',
      difficulty: 'Easy',
      description: 'Explore ancient Mayan ruins with fewer crowds than Tikal. Important historical site with ceremonial platforms.',
      bestFor: 'History buffs, families, travelers seeking quieter sites',
      worthIt: 'Good option if you want Mayan ruins without the long journey to Tikal. Less impressive but more accessible.',
      image: 'https://readdy.ai/api/search-image?query=Iximche%20Mayan%20ruins%20Guatemala%20ancient%20pyramids%2C%20stone%20structures%2C%20archaeological%20site%2C%20historical%20monuments%2C%20peaceful%20setting%2C%20cultural%20heritage&width=600&height=400&seq=iximche-trip&orientation=landscape',
      link: '/antigua-guatemala-travel-guide'
    },
    {
      title: 'Hobbitenango',
      duration: '4-6 hours',
      distance: '45 minutes',
      difficulty: 'Easy',
      description: 'Whimsical hobbit village with giant hand sculptures, mountain views, and Instagram-worthy photo ops.',
      bestFor: 'Families, Instagram enthusiasts, relaxed day out',
      worthIt: 'Fun and unique, especially for families with kids or those wanting lighter activities.',
      image: 'https://readdy.ai/api/search-image?query=Hobbitenango%20Guatemala%20giant%20hand%20sculpture%2C%20hobbit%20houses%2C%20mountain%20backdrop%2C%20whimsical%20theme%20park%2C%20colorful%20fantasy%20architecture%2C%20fun%20day%20trip&width=600&height=400&seq=hobbit-trip&orientation=landscape',
      link: '/hobbitenango-antigua-guatemala'
    },
    {
      title: 'Tikal from Antigua',
      duration: 'Very long day (16+ hours) or overnight',
      distance: '8-9 hours by bus',
      difficulty: 'Easy walking, exhausting travel',
      description: 'Guatemala\'s most famous Mayan ruins. Massive temples rising from the jungle. Long journey but iconic.',
      bestFor: 'Dedicated history enthusiasts, bucket list travelers',
      worthIt: 'Only if you can\'t do an overnight trip to Flores. The travel time makes it exhausting as a day trip.',
      image: 'https://readdy.ai/api/search-image?query=Tikal%20Guatemala%20Mayan%20temples%20rising%20from%20jungle%2C%20ancient%20pyramids%2C%20archaeological%20wonder%2C%20UNESCO%20site%2C%20dramatic%20ruins%2C%20cultural%20heritage&width=600&height=400&seq=tikal-daytrip&orientation=landscape',
      link: '/antigua-guatemala-travel-guide'
    }
  ];

  const volcanoTrips = [
    {
      name: 'Pacaya',
      difficulty: 'Easy-Moderate',
      duration: '4-5 hours',
      highlight: 'Active lava flows',
      best: 'First-timers, families'
    },
    {
      name: 'Acatenango',
      difficulty: 'Challenging',
      duration: '2 days/1 night',
      highlight: 'Fuego eruptions, summit sunrise',
      best: 'Fit hikers, adventure seekers'
    }
  ];

  const faqs = [
    {
      question: 'What is the best day trip from Antigua Guatemala?',
      answer: 'For most travelers, Pacaya Volcano is the best day trip—it\'s accessible, affordable ($50-60), and offers guaranteed active lava sightings in just 4-5 hours. If you have a full day and want stunning scenery, Lake Atitlán is incredible. For culture, visit Chichicastenango Market on Thursday or Sunday.'
    },
    {
      question: 'Can you visit Lake Atitlán in one day from Antigua?',
      answer: 'Yes, but it\'s a long day (10-12 hours total). The drive takes 2.5-3 hours each way. You\'ll have 4-5 hours at the lake to visit 2-3 villages by boat. It\'s worth it if you can\'t stay overnight, but two days at the lake is ideal to fully experience it.'
    },
    {
      question: 'Is Pacaya Volcano worth it?',
      answer: 'Absolutely. Pacaya is one of the best value activities in Guatemala. For $50-60, you get to hike an active volcano, see glowing lava flows, and roast marshmallows over volcanic heat. It\'s accessible for most fitness levels and takes just half a day from Antigua.'
    },
    {
      question: 'Are day trips from Antigua safe?',
      answer: 'Yes, day trips with reputable tour companies are very safe. Tours use experienced guides, reliable transportation, and follow established routes. Pacaya, Lake Atitlán, and Chichicastenango are all safe with organized tours. Always book through established agencies and avoid traveling alone to remote areas.'
    },
    {
      question: 'How much do day tours from Antigua cost?',
      answer: 'Prices vary by destination: Pacaya Volcano ($50-60), Acatenango overnight ($65-100), Lake Atitlán ($40-60), Chichicastenango Market ($35-50), Coffee Tours ($25-40), Hobbitenango ($30-45), Iximché Ruins ($40-55). Prices typically include transportation, guide, and entrance fees.'
    },
    {
      question: 'Do I need a guide for day trips from Antigua?',
      answer: 'For volcano hikes (Pacaya, Acatenango), a guide is mandatory for safety and navigation. For Lake Atitlán and Chichicastenango, you can go independently via shuttle, but tours provide better logistics and local insight. Coffee tours and Iximché are easier with guides but can be done independently.'
    },
    {
      question: 'What is the closest volcano to Antigua?',
      answer: 'Pacaya Volcano is the closest active volcano, about 1.5 hours from Antigua. You can also see Volcán de Agua (inactive) from Antigua—it\'s the massive volcano directly south of the city. Acatenango and Fuego are about 1.5 hours away as well.'
    },
    {
      question: 'Can you do Tikal as a day trip from Antigua?',
      answer: 'Technically yes, but it\'s not not recommended. The journey takes 8-9 hours each way by bus or 1 hour by flight (expensive). You\'ll spend more time traveling than exploring. It\'s much better to do Tikal as an overnight trip from Flores or skip it if you\'re short on time.'
    }
  ];

  const relatedGuides = [
    {
      title: 'Acatenango Volcano Hike',
      description: 'Complete guide to hiking Guatemala\'s most iconic volcano',
      path: '/acatenango-hike-from-antigua'
    },
    {
      title: 'Things to Do in Antigua',
      description: 'Best attractions and activities in Antigua Guatemala',
      path: '/things-to-do-in-antigua-guatemala'
    },
    {
      title: 'Antigua Travel Guide',
      description: 'Everything you need to plan your Antigua trip',
      path: '/antigua-guatemala-travel-guide'
    },
    {
      title: 'Antigua Itineraries',
      description: '2, 3, and 5-day itinerary suggestions',
      path: '/itineraries'
    },
    {
      title: 'Antigua Weather Guide',
      description: 'Best time to visit and seasonal recommendations',
      path: '/best-time-to-visit-antigua-guatemala'
    },
    {
      title: 'Where to Stay in Antigua',
      description: 'Hotel recommendations and neighborhood guides',
      path: '/where-to-stay-in-antigua-guatemala'
    }
  ];

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        '@id': 'https://la-antigua-guatemala.com/day-trips-from-antigua-guatemala#article',
        headline: 'Day Trips from Antigua Guatemala: Complete Guide',
        description: 'Best day trips from Antigua Guatemala including volcano hikes, Lake Atitlán, markets, ruins and coffee tours. Full guide for US travelers.',
        image: 'https://readdy.ai/api/search-image?query=Guatemala%20adventure%20travel%20collage%20showing%20volcano%20hikes%2C%20colorful%20markets%2C%20Mayan%20ruins%2C%20coffee%20plantations%2C%20diverse%20day%20trip%20activities%2C%20exciting%20exploration%20opportunities&width=1920&height=600&seq=daytrips-hero&orientation=landscape',
        datePublished: '2026-02-20',
        dateModified: '2026-02-20',
        author: {
          '@type': 'Organization',
          name: 'La Antigua Guatemala Travel Guide'
        },
        publisher: {
          '@type': 'Organization',
          name: 'La Antigua Guatemala Travel Guide',
          logo: {
            '@type': 'ImageObject',
            url: 'https://la-antigua-guatemala.com/logo.png'
          }
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://la-antigua-guatemala.com/day-trips-from-antigua-guatemala'
        }
      },
      {
        '@type': 'FAQPage',
        '@id': 'https://la-antigua-guatemala.com/day-trips-from-antigua-guatemala#faq',
        mainEntity: faqs.map(faq => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer
          }
        }))
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="Day Trips from Antigua Guatemala (Complete Guide)"
        description="Best day trips from Antigua Guatemala including volcano hikes, Lake Atitlán, markets, ruins and coffee tours. Full guide for US travelers."
        canonical="https://la-antigua-guatemala.com/day-trips-from-antigua-guatemala"
        keywords="day trips from antigua guatemala, antigua guatemala day trips, best day trips from antigua, day tours from antigua guatemala, things to do near antigua guatemala, one day trips from antigua, antigua volcano day trip, antigua to lake atitlan day trip"
        type="article"
        schema={schema}
        lastModified="2026-02-20"
        ogImage={{
          url: 'https://public.readdy.ai/ai/img_res/657c57f995ea55dc36d70806d5ed278b.jpg',
          width: '1200',
          height: '630'
        }}
      />
      
      <Navbar darkText />
      
      <div className="pt-20">
        {/* Hero */}
        <section className="relative min-h-[50vh] md:h-[50vh] flex items-center justify-center pt-8 pb-12 md:py-0">
          <div className="absolute inset-0">
            <img 
              src="https://readdy.ai/api/search-image?query=Guatemala%20adventure%20travel%20collage%20showing%20volcano%20hikes%2C%20colorful%20markets%2C%20Mayan%20ruins%2C%20coffee%20plantations%2C%20diverse%20day%20trip%20activities%2C%20exciting%20exploration%20opportunities&width=1920&height=600&seq=daytrips-hero&orientation=landscape"
              alt="Day Trips from Antigua Guatemala"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
          </div>
          <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-6xl font-bold mb-4 md:mb-6">Day Trips from Antigua Guatemala: Complete Guide</h1>
            <p className="text-base md:text-2xl">Explore volcanoes, markets, ruins, and more from your Antigua base</p>
          </div>
        </section>

        {/* Breadcrumbs */}
        <Breadcrumbs 
          items={[
            { label: 'Day Trips from Antigua', path: '/day-trips-from-antigua-guatemala' }
          ]}
        />

        {/* Intro */}
        <section className="py-12 bg-white">
          <div className="max-w-4xl mx-auto px-4">
            <p className="text-xl text-gray-700 leading-relaxed mb-6">
              <strong>This guide covers the best day trips from Antigua Guatemala</strong>—from active volcano hikes and indigenous markets to ancient Mayan ruins and world-class coffee plantations. Antigua Guatemala's central location in the highlands makes it the perfect base for exploring some of the country's most spectacular destinations, all within 1-3 hours.
            </p>
            <p className="text-xl text-gray-700 leading-relaxed mb-6">
              Whether you have just a few hours or a full day, these day trips from Antigua offer incredible diversity. Most tours depart early morning and return by evening, making it easy to maximize your time. If you're still planning your logistics, check our <Link to="/guatemala-city-airport-to-antigua" className="text-teal-500 hover:text-teal-600 font-medium">airport transfer guide</Link> to get from Guatemala City to Antigua smoothly.
            </p>
            <p className="text-xl text-gray-700 leading-relaxed">
              Below you'll find detailed information on each day trip, a comparison table, top picks by traveler type, and practical tips for US travelers.
            </p>
          </div>
        </section>

        {/* Best Day Trips Overview */}
        <section className="py-12 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Best Day Trips from Antigua Guatemala</h2>
            <p className="text-xl text-gray-700 mb-8">
              Here are the top day trips from Antigua, organized by experience type and difficulty level.
            </p>
            
            <div className="grid md:grid-cols-2 gap-8">
              {dayTrips.map((trip, index) => (
                <div key={index} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition">
                  <div className="relative h-64">
                    <img 
                      src={trip.image}
                      alt={trip.title}
                      className="w-full h-full object-cover object-center"
                    />
                    <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-gray-900">
                      {trip.duration}
                    </div>
                    <div className="absolute top-4 left-4 bg-teal-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                      {trip.difficulty}
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">{trip.title}</h3>
                    <p className="text-gray-600 mb-4">{trip.description}</p>
                    
                    <div className="space-y-3 mb-6">
                      <div className="flex items-start">
                        <i className="ri-map-pin-line text-teal-500 mt-1 mr-2"></i>
                        <div>
                          <strong className="text-gray-900">Distance:</strong>
                          <span className="text-gray-700 ml-2">{trip.distance} from Antigua</span>
                        </div>
                      </div>
                      
                      <div className="flex items-start">
                        <i className="ri-user-line text-teal-500 mt-1 mr-2"></i>
                        <div>
                          <strong className="text-gray-900">Best for:</strong>
                          <span className="text-gray-700 ml-2">{trip.bestFor}</span>
                        </div>
                      </div>
                      
                      <div className="flex items-start">
                        <i className="ri-star-line text-teal-500 mt-1 mr-2"></i>
                        <div>
                          <strong className="text-gray-900">Worth it?</strong>
                          <span className="text-gray-700 ml-2">{trip.worthIt}</span>
                        </div>
                      </div>
                    </div>
                    
                    <Link to={trip.link} className="inline-flex items-center text-teal-500 font-semibold hover:text-teal-600 transition">
                      Read Full Guide
                      <i className="ri-arrow-right-line ml-2"></i>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Comparison Table */}
        <section className="py-16 bg-white">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Day Trips Comparison Table</h2>
            <p className="text-xl text-gray-700 mb-8">
              Quick side-by-side comparison of every day trip from Antigua Guatemala to help you decide.
            </p>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse bg-white rounded-lg overflow-hidden shadow-sm">
                <thead>
                  <tr className="bg-teal-500 text-white">
                    <th className="text-left px-5 py-4 font-semibold text-sm">Day Trip</th>
                    <th className="text-left px-5 py-4 font-semibold text-sm">Travel Time (one-way)</th>
                    <th className="text-left px-5 py-4 font-semibold text-sm">Duration</th>
                    <th className="text-left px-5 py-4 font-semibold text-sm">Typical Cost</th>
                    <th className="text-left px-5 py-4 font-semibold text-sm">Best For</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition">
                    <td className="px-5 py-4 font-semibold text-gray-900">Pacaya Volcano</td>
                    <td className="px-5 py-4 text-gray-700">1.5 hours</td>
                    <td className="px-5 py-4 text-gray-700">4-5 hours</td>
                    <td className="px-5 py-4 text-gray-700">$50-60</td>
                    <td className="px-5 py-4 text-gray-700">First-timers, families</td>
                  </tr>
                  <tr className="border-b border-gray-100 bg-gray-50/50 hover:bg-gray-50 transition">
                    <td className="px-5 py-4 font-semibold text-gray-900">Lake Atitl&aacute;n</td>
                    <td className="px-5 py-4 text-gray-700">2.5-3 hours</td>
                    <td className="px-5 py-4 text-gray-700">10-12 hours</td>
                    <td className="px-5 py-4 text-gray-700">$40-60</td>
                    <td className="px-5 py-4 text-gray-700">Nature lovers, photographers</td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition">
                    <td className="px-5 py-4 font-semibold text-gray-900">Chichicastenango</td>
                    <td className="px-5 py-4 text-gray-700">2 hours</td>
                    <td className="px-5 py-4 text-gray-700">8-10 hours</td>
                    <td className="px-5 py-4 text-gray-700">$35-50</td>
                    <td className="px-5 py-4 text-gray-700">Shoppers, culture enthusiasts</td>
                  </tr>
                  <tr className="border-b border-gray-100 bg-gray-50/50 hover:bg-gray-50 transition">
                    <td className="px-5 py-4 font-semibold text-gray-900">Acatenango (overnight)</td>
                    <td className="px-5 py-4 text-gray-700">1.5 hours</td>
                    <td className="px-5 py-4 text-gray-700">2 days / 1 night</td>
                    <td className="px-5 py-4 text-gray-700">$65-100</td>
                    <td className="px-5 py-4 text-gray-700">Fit hikers, adventure seekers</td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition">
                    <td className="px-5 py-4 font-semibold text-gray-900">Coffee Plantation</td>
                    <td className="px-5 py-4 text-gray-700">15-30 min</td>
                    <td className="px-5 py-4 text-gray-700">3-4 hours</td>
                    <td className="px-5 py-4 text-gray-700">$25-40</td>
                    <td className="px-5 py-4 text-gray-700">Coffee lovers, relaxed travelers</td>
                  </tr>
                  <tr className="border-b border-gray-100 bg-gray-50/50 hover:bg-gray-50 transition">
                    <td className="px-5 py-4 font-semibold text-gray-900">Iximch&eacute; Ruins</td>
                    <td className="px-5 py-4 text-gray-700">1 hour</td>
                    <td className="px-5 py-4 text-gray-700">4-5 hours</td>
                    <td className="px-5 py-4 text-gray-700">$40-55</td>
                    <td className="px-5 py-4 text-gray-700">History buffs, families</td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition">
                    <td className="px-5 py-4 font-semibold text-gray-900">Hobbitenango</td>
                    <td className="px-5 py-4 text-gray-700">45 min</td>
                    <td className="px-5 py-4 text-gray-700">4-6 hours</td>
                    <td className="px-5 py-4 text-gray-700">$30-45</td>
                    <td className="px-5 py-4 text-gray-700">Families, Instagram fans</td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition">
                    <td className="px-5 py-4 font-semibold text-gray-900">Tikal (from Antigua)</td>
                    <td className="px-5 py-4 text-gray-700">8-9 hours (bus) / 1h (flight)</td>
                    <td className="px-5 py-4 text-gray-700">16+ hours or overnight</td>
                    <td className="px-5 py-4 text-gray-700">$80-250+</td>
                    <td className="px-5 py-4 text-gray-700">Bucket list travelers</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Top Picks by Traveler Type */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Top Picks by Traveler Type</h2>
            <p className="text-xl text-gray-700 mb-8">
              Not sure which day trip from Antigua Guatemala is right for you? Here are our top recommendations based on your travel style.
            </p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <div className="bg-white rounded-lg p-6 shadow-sm border-t-4 border-teal-500">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full mb-3">
                  <i className="ri-walk-line text-xl text-teal-600"></i>
                </div>
                <p className="text-sm font-semibold text-teal-600 mb-1">Best Easy Day Trip</p>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Pacaya Volcano</h3>
                <p className="text-gray-600 text-sm">Accessible active volcano with lava sightings. Half-day, family-friendly, and affordable.</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-sm border-t-4 border-amber-500">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-full mb-3">
                  <i className="ri-ancient-gate-line text-xl text-amber-600"></i>
                </div>
                <p className="text-sm font-semibold text-amber-600 mb-1">Best Cultural Experience</p>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Chichicastenango Market</h3>
                <p className="text-gray-600 text-sm">Guatemala's most vibrant indigenous market. Authentic Maya K'iche' culture every Thursday and Sunday.</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-sm border-t-4 border-emerald-500">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-full mb-3">
                  <i className="ri-landscape-line text-xl text-emerald-600"></i>
                </div>
                <p className="text-sm font-semibold text-emerald-600 mb-1">Best Nature Trip</p>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Lake Atitl&aacute;n</h3>
                <p className="text-gray-600 text-sm">Stunning volcanic lake surrounded by traditional villages. One of the most beautiful lakes in the world.</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-sm border-t-4 border-rose-500">
                <div className="w-10 h-10 flex items-center justify-center bg-rose-100 rounded-full mb-3">
                  <i className="ri-cup-line text-xl text-rose-600"></i>
                </div>
                <p className="text-sm font-semibold text-rose-600 mb-1">Best Half-Day Trip</p>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Coffee Plantation Tour</h3>
                <p className="text-gray-600 text-sm">Just 15-30 minutes from Antigua. Educational, delicious, and perfect for a relaxed morning.</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-sm border-t-4 border-violet-500">
                <div className="w-10 h-10 flex items-center justify-center bg-violet-100 rounded-full mb-3">
                  <i className="ri-camera-line text-xl text-violet-600"></i>
                </div>
                <p className="text-sm font-semibold text-violet-600 mb-1">Best &quot;Instagram&quot; Trip</p>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Hobbitenango</h3>
                <p className="text-gray-600 text-sm">Giant hand sculptures, hobbit houses, and panoramic mountain views. The most photogenic spot near Antigua.</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-sm border-t-4 border-orange-500">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-full mb-3">
                  <i className="ri-fire-line text-xl text-orange-600"></i>
                </div>
                <p className="text-sm font-semibold text-orange-600 mb-1">Best Epic Adventure</p>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Acatenango Overnight</h3>
                <p className="text-gray-600 text-sm">Camp at 3,976m with front-row views of Fuego erupting. The highlight of most Guatemala trips.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Volcano Day Trips Section */}
        <section className="py-16 bg-white">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Volcano Day Trips from Antigua</h2>
            <p className="text-xl text-gray-700 mb-8">
              Antigua is surrounded by volcanoes, and hiking them is one of Guatemala's most iconic experiences. Here's how to choose between the two main options. If you're wondering about safety on these hikes, our <Link to="/is-antigua-guatemala-safe" className="text-teal-500 hover:text-teal-600 font-medium">Antigua safety guide</Link> covers everything you need to know.
            </p>

            <div className="grid md:grid-cols-2 gap-8 mb-10">
              {volcanoTrips.map((volcano, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{volcano.name} Volcano</h3>
                  <div className="space-y-2 mb-4">
                    <p className="text-gray-700"><strong>Difficulty:</strong> {volcano.difficulty}</p>
                    <p className="text-gray-700"><strong>Duration:</strong> {volcano.duration}</p>
                    <p className="text-gray-700"><strong>Highlight:</strong> {volcano.highlight}</p>
                    <p className="text-gray-700"><strong>Best for:</strong> {volcano.best}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-teal-50 border-l-4 border-teal-500 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Which Volcano Should You Choose?</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 mt-1 mr-2"></i>
                  <span><strong>Choose Pacaya if:</strong> You want an easier hike, have limited time (half day), traveling with family, or want guaranteed lava sightings without camping.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 mt-1 mr-2"></i>
                  <span><strong>Choose Acatenango if:</strong> You're fit, want an epic adventure, can handle cold and altitude, and want to witness Fuego's eruptions from a front-row seat.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 mt-1 mr-2"></i>
                  <span><strong>Do both if you can:</strong> They're completely different experiences. Pacaya is accessible and fun; Acatenango is challenging and unforgettable.</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Cultural & Market Day Trips */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Cultural & Market Day Trips</h2>
            <p className="text-xl text-gray-700 mb-10">
              Experience authentic Guatemalan culture, indigenous traditions, and ancient history with these cultural day trips.
            </p>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-shopping-bag-3-line text-3xl text-teal-500"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Chichicastenango Market</h3>
                <p className="text-gray-700 mb-4">
                  Guatemala's most famous indigenous market operates Thursday and Sunday. Vibrant textiles, handicrafts, and authentic Maya K'iche' culture. The market fills the entire town center with hundreds of vendors.
                </p>
                <p className="text-sm text-gray-600 mb-4"><strong>Best for:</strong> Shoppers, photographers, cultural immersion</p>
                <Link to="/antigua-to-chichicastenango" className="text-teal-500 font-semibold hover:text-teal-600">
                  Full Guide →
                </Link>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-ancient-gate-line text-3xl text-teal-500"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Iximché Ruins</h3>
                <p className="text-gray-700 mb-4">
                  Ancient Maya capital with ceremonial platforms and pyramids. Less crowded than Tikal but still historically significant. The site is peaceful and you can often see traditional Maya ceremonies being performed.
                </p>
                <p className="text-sm text-gray-600 mb-4"><strong>Best for:</strong> History enthusiasts, families, quieter experiences</p>
                <span className="text-gray-500 text-sm">Contact tour operators in Antigua for bookings</span>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-cup-line text-3xl text-teal-500"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Coffee Plantation Tours</h3>
                <p className="text-gray-700 mb-4">
                  Tour world-renowned coffee farms in the Antigua valley. Learn about cultivation, processing, roasting, and taste exceptional beans. Most tours are half-day and include transportation from Antigua.
                </p>
                <p className="text-sm text-gray-600 mb-4"><strong>Best for:</strong> Coffee lovers, morning activities, educational experiences</p>
                <span className="text-gray-500 text-sm">Book through hotels or tour operators in Antigua</span>
              </div>
            </div>
          </div>
        </section>

        {/* Nature & Scenic Day Trips */}
        <section className="py-16 bg-white">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Nature & Scenic Day Trips</h2>
            <p className="text-xl text-gray-700 mb-10">
              Discover Guatemala's stunning natural beauty with these scenic day trips featuring lakes, mountains, and unique attractions. We recommend <Link to="/best-hotels-in-antigua-guatemala" className="text-teal-500 hover:text-teal-600 font-medium">booking a hotel in Antigua</Link> as your base—most tours offer convenient pickup from local hotels.
            </p>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gray-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Lake Atitlán</h3>
                <p className="text-gray-700 mb-4">
                  Often called the most beautiful lake in the world, Lake Atitlán is surrounded by three volcanoes and traditional Maya villages. Day trips typically visit 2-3 villages by boat, including San Juan La Laguna (art cooperatives), Santiago Atitlán (largest village), and Panajachel (tourist hub).
                </p>
                <p className="text-gray-700 mb-4">
                  The journey takes 2.5-3 hours each way through stunning highland scenery. You'll have 4-5 hours at the lake to explore, shop for handicrafts, and enjoy lakeside restaurants.
                </p>
                <div className="bg-white p-4 rounded-lg mb-4">
                  <p className="text-sm text-gray-700"><strong>Duration:</strong> Full day (10-12 hours)</p>
                  <p className="text-sm text-gray-700"><strong>Distance:</strong> 2.5-3 hours from Antigua</p>
                  <p className="text-sm text-gray-700"><strong>Best for:</strong> Nature lovers, photographers, cultural explorers</p>
                </div>
                <Link to="/antigua-to-lake-atitlan-shuttle" className="inline-flex items-center text-teal-500 font-semibold hover:text-teal-600">
                  Lake Atitlán Guide
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Hobbitenango</h3>
                <p className="text-gray-700 mb-4">
                  A whimsical theme park featuring hobbit houses, giant hand sculptures, and panoramic mountain views. It's become one of Guatemala's most Instagram-famous spots, especially the giant hand reaching out over the valley.
                </p>
                <p className="text-gray-700 mb-4">
                  The park includes restaurants, zip lines, and plenty of photo opportunities. It's a lighter, more relaxed day trip perfect for families or those wanting a break from intense hiking.
                </p>
                <div className="bg-white p-4 rounded-lg mb-4">
                  <p className="text-sm text-gray-700"><strong>Duration:</strong> 4-6 hours</p>
                  <p className="text-sm text-gray-700"><strong>Distance:</strong> 45 minutes from Antigua</p>
                  <p className="text-sm text-gray-700"><strong>Best for:</strong> Families, Instagram photos, relaxed outings</p>
                </div>
                <Link to="/hobbitenango-antigua-guatemala" className="inline-flex items-center text-teal-500 font-semibold hover:text-teal-600">
                  Hobbitenango Guide
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Mid-page CTA */}
        <section className="py-16 bg-teal-500">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">Ready to Book Your Day Trips?</h2>
            <p className="text-xl text-white/90 mb-8">Get personalized recommendations and help planning your perfect Antigua itinerary with day trips included.</p>
            <Link to="/plan-my-antigua-trip" className="inline-block bg-white hover:bg-gray-100 text-teal-500 px-8 py-4 rounded-lg font-semibold text-lg transition whitespace-nowrap">
              Plan My Antigua Trip
            </Link>
          </div>
        </section>

        {/* How to Choose */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-gray-900 mb-8">How to Choose the Best Day Trip</h2>
            
            <div className="space-y-6">
              <div className="border-l-4 border-teal-500 pl-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Consider Your Time Available</h3>
                <p className="text-gray-700 mb-2"><strong>Half day (4-5 hours):</strong> Pacaya Volcano, Coffee Tours, Hobbitenango</p>
                <p className="text-gray-700 mb-2"><strong>Full day (8-12 hours):</strong> Lake Atitlán, Chichicastenango, Iximché</p>
                <p className="text-gray-700"><strong>Overnight:</strong> Acatenango Volcano, Tikal (better as 2-day trip)</p>
              </div>

              <div className="border-l-4 border-teal-500 pl-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Match Your Fitness Level</h3>
                <p className="text-gray-700 mb-2"><strong>Easy:</strong> Lake Atitlán, Chichicastenango, Coffee Tours, Hobbitenango, Iximché</p>
                <p className="text-gray-700 mb-2"><strong>Moderate:</strong> Pacaya Volcano (some steep sections but manageable)</p>
                <p className="text-gray-700"><strong>Challenging:</strong> Acatenango (high altitude, steep terrain, cold temperatures)</p>
              </div>

              <div className="border-l-4 border-teal-500 pl-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Budget Considerations</h3>
                <p className="text-gray-700 mb-2"><strong>Budget-friendly ($25-50):</strong> Coffee Tours, Chichicastenango, Hobbitenango</p>
                <p className="text-gray-700 mb-2"><strong>Mid-range ($50-70):</strong> Pacaya, Lake Atitlán, Iximché</p>
                <p className="text-gray-700"><strong>Premium ($70-100+):</strong> Acatenango overnight, Tikal flights</p>
              </div>

              <div className="border-l-4 border-teal-500 pl-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Travel Style Preferences</h3>
                <p className="text-gray-700 mb-2"><strong>Adventure seekers:</strong> Acatenango, Pacaya, ATV tours</p>
                <p className="text-gray-700 mb-2"><strong>Culture enthusiasts:</strong> Chichicastenango, Iximché, Coffee Tours</p>
                <p className="text-gray-700 mb-2"><strong>Nature lovers:</strong> Lake Atitlán, volcano hikes, scenic drives</p>
                <p className="text-gray-700"><strong>Families:</strong> Pacaya (older kids), Hobbitenango, Coffee Tours</p>
              </div>
            </div>
          </div>
        </section>

        {/* Best Time of Year */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-gray-900 mb-8">Best Time of Year for Day Trips</h2>
            
            <div className="bg-white p-8 rounded-lg shadow-sm mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Dry Season (November - April)</h3>
              <p className="text-gray-700 mb-4">
                <strong>Best for:</strong> All day trips, especially volcano hikes and Lake Atitlán
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 mt-1 mr-2"></i>
                  <span>Clear skies and excellent visibility for volcano views</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 mt-1 mr-2"></i>
                  <span>Minimal rain means safer hiking conditions</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 mt-1 mr-2"></i>
                  <span>Lake Atitlán is stunning with blue skies</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 mt-1 mr-2"></i>
                  <span>Peak season means more tour availability but also more crowds</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Rainy Season (May - October)</h3>
              <p className="text-gray-700 mb-4">
                <strong>Best for:</strong> Cultural trips (markets, coffee tours, ruins)
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-alert-line text-amber-500 mt-1 mr-2"></i>
                  <span>Afternoon rain is common—volcano views may be obscured</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-alert-line text-amber-500 mt-1 mr-2"></i>
                  <span>Acatenango can be cold, wet, and muddy (less recommended)</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 mt-1 mr-2"></i>
                  <span>Fewer tourists and lower prices</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 mt-1 mr-2"></i>
                  <span>Mornings are usually clear—book early departures</span>
                </li>
              </ul>
            </div>

            <div className="bg-teal-50 border-l-4 border-teal-500 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Special Considerations</h3>
              <p className="text-gray-700 mb-2">
                <strong>Chichicastenango Market:</strong> Only operates Thursday and Sunday—plan accordingly
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Semana Santa (Easter Week):</strong> Extremely crowded in Antigua; day trips are a good escape
              </p>
              <p className="text-gray-700">
                <strong>Volcano visibility:</strong> December-February typically offers the clearest views
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-gray-900 mb-10">Frequently Asked Questions</h2>
            
            <div className="space-y-6">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{faq.question}</h3>
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Related Guides */}
        <RelatedGuides guides={relatedGuides} />

        {/* Next Steps */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Next Steps for Planning Your Antigua Trip</h2>
            
            <div className="grid md:grid-cols-2 gap-6">
              <Link to="/itineraries" className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition group">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-calendar-line text-2xl text-teal-500"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-500 transition">View Sample Itineraries</h3>
                    <p className="text-gray-600">2-5 day itineraries with day trips included</p>
                  </div>
                </div>
              </Link>

              <Link to="/guatemala-city-airport-to-antigua" className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition group">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-plane-line text-2xl text-teal-500"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-500 transition">Airport Transportation</h3>
                    <p className="text-gray-600">Shuttles and transfers from Guatemala City</p>
                  </div>
                </div>
              </Link>

              <Link to="/best-hotels-in-antigua-guatemala" className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition group">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-hotel-line text-2xl text-teal-500"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-500 transition">Where to Stay</h3>
                    <p className="text-gray-600">Best neighborhoods and hotels in Antigua</p>
                  </div>
                </div>
              </Link>

              <Link to="/plan-my-antigua-trip" className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition group">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-map-line text-2xl text-teal-500"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-500 transition">Get Custom Help</h3>
                    <p className="text-gray-600">Personalized itinerary planning assistance</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="py-16 bg-teal-500">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">Get Your Custom Antigua Itinerary</h2>
            <p className="text-xl text-white/90 mb-8">Tell us your interests, travel dates, and fitness level—we'll help you choose the perfect day trips and create a personalized itinerary.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/plan-my-antigua-trip" className="inline-block bg-white hover:bg-gray-100 text-teal-500 px-8 py-4 rounded-lg font-semibold text-lg transition whitespace-nowrap">
                Plan My Trip
              </Link>
              <Link to="/antigua-guatemala-itineraries" className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition whitespace-nowrap">
                View Sample Itineraries
              </Link>
            </div>
          </div>
        </section>

        {/* Last Updated */}
        <section className="py-8 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <p className="text-sm text-gray-600">
              Written by the La Antigua Guatemala travel team | 
              <Link to="/editorial-policy" className="text-teal-500 hover:text-teal-600 ml-2">Editorial Policy</Link>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}